import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";

import { Array, BigPictureDashBoardPieChartLegend, Common, Gender, KSResults, KSResultsScience, SUCCESS, SenStatusOptions, WARNING } from "../../../helper";
import { isEmptyObject } from "../../../util";
import { styles } from "../";
import { success } from "../../Shared";
import * as commonApi from "../../../api/commonApi";

import "../../../assets/stlyes/Modals.css";

import warningImg from "../../../assets/images/Warning.svg"

const EditPupil = (props) => {
  const { isPupilId, setEditPupil, getData } = props;
  const [isSenStatus, setIsSenStatus] = useState();
  const [pupilDetails, setPupilDetails] = useState();
  const [defaultOption, setDefaultOption] = useState();
  const [isCla, setIsCla] = useState();
  const [isFsm, setIsFsm] = useState();
  const [isFsm6, setIsFsm6] = useState();
  const [isEal, setIsEal] = useState();
  const [isSc, setIsSc] = useState();
  const [isEHCP, setIsEHCP] = useState();
  const [genderOptions, setGenderOptions] = useState();
  const [yearOptions, setYearOptions] = useState();
  const [isGender, setIsGender] = useState();
  const [isYear, setIsYear] = useState();
  const [commonKS, setCommonKS] = useState();
  const [commonKSScience, setCommonKSScience] = useState();
  const [ksResult, setKsResult] = useState();
  const [pupilPresentYear,setPupilPresentYear]=useState();
  const [warning, setWarning] = useState(false);

  const style = {
    modal_form: {
      width: "100%",
    },
  };


  const SignupSchema = Yup.object().shape({
    foreName: Yup.string().trim(" ").max(25, Common.LengthRestriction).required(Common.Required),
    surName: Yup.string().trim(" ").max(25, Common.LengthRestriction).required(Common.Required),
  });

  const getSelectedValue = (event) => {
    if (event.label === Common.Ehcp) {
      setIsSenStatus(true);
      setIsEHCP(true);
    } else if (event.label === Common.SEND) {
      setIsSenStatus(true);
      setIsEHCP(false);
    } else {
      setIsSenStatus(false);
      setIsEHCP(false);
    }
  };

  const setDefaultDropDown = () => {
    return (isSenStatus && isEHCP ? { label: Common.Ehcp, value: Common.Ehcp } : isSenStatus ? { label: Common.SEND, value: Common.SEND } : { label: Common.NotSend, value: Common.NotSend })
  }

  const getPupilData = async () => {
    const getPupil = await commonApi.getPupil({
      id: isPupilId,
    });
    if (!isEmptyObject(getPupil.Items)) {
      const individualData = getPupil.Items;
      const found = SenStatusOptions.find(
        (element) => element.value === individualData.senStatus
      );
      setDefaultOption(found);
      setIsFsm6(individualData.otherNeeds.freeSchoolMealsE6);
      setIsFsm(individualData.otherNeeds.freeSchoolMeals);
      setIsCla(individualData.otherNeeds.childLookedAfter);
      setIsEal(individualData.otherNeeds.eal);
      setIsSc(individualData.otherNeeds.serviceChild);
      setPupilDetails(individualData);
      setIsSenStatus(individualData.senStatus);
      setIsEHCP(individualData.ehcp);
      setIsGender(individualData.gender);
      setIsYear(individualData.year);
      setKsResult(individualData.ksResults);
      setPupilPresentYear(individualData.year);
    }
  };

  const updatePupil = async (pupilFormData) => {
    const updatePupil = await commonApi.updatePupil(
      pupilFormData
    );
    if (!isEmptyObject(updatePupil)) {
      setEditPupil(false);
      getData();
      success(SUCCESS.PUPIL_UPDATED_SUCCESSFULLY)
    }
  };

  useEffect(() => {
    getPupilData();
    const genderOptionsArray = Object.keys(Gender).map((key) => ({
      value: Gender[key] === Gender.Unspecified ? "Not Specified" : key,
      label: Gender[key] === Gender.Unspecified ? "Not Specified" : key
    }));
    genderOptionsArray.pop();// Remove the last object because in constant it contains all
    setGenderOptions(genderOptionsArray);

    const yearOptionsArray = Array?.Years.map((year) => ({ value: year, label: `${Common.Year} ${year}` }))
    yearOptionsArray.shift(); // remove first item from array because in constant it contains all
    setYearOptions(yearOptionsArray);

    setCommonKS(KSResults.map((result) => ({ value: result, label: result })));
    setCommonKSScience(KSResultsScience.map((result) => ({ value: result, label: result })));
  }, []);

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          foreName: pupilDetails && pupilDetails.firstName,
          surName: pupilDetails && pupilDetails.lastName,
          senStatus: pupilDetails && pupilDetails.senStatus,
          year: pupilDetails && pupilDetails.year,
          gender: pupilDetails && pupilDetails.gender,
          myCheck: "",
          Ks1Maths: pupilDetails && pupilDetails.ksResults?.ks1Results.Maths,
          Ks1Science: pupilDetails && pupilDetails.ksResults?.ks1Results.Science,
          Ks1Reading: pupilDetails && pupilDetails.ksResults?.ks1Results.Reading,
          Ks1Writing: pupilDetails && pupilDetails.ksResults?.ks1Results.Writing,
        }}
        validationSchema={SignupSchema}
        validate={() => {
          const errors = {};
          return errors;
        }}
        onSubmit={(values) => {
          const pupilFormData = {
            id: isPupilId,
            firstName: values.foreName,
            lastName: values.surName,
            senStatus: isSenStatus,
            otherNeeds: {
              childLookedAfter: isCla,
              eal: isEal,
              freeSchoolMeals: isFsm,
              freeSchoolMealsE6: isFsm6,
              serviceChild: isSc,
            },
            ehcp: isEHCP,
            // year: isYear,
            // gender: isGender,
            // ksResults: {
            //   ks1Results: {
            //     Writing: isYear > 2 ? values.Ks1Writing : "",
            //     Reading: isYear > 2 ? values.Ks1Reading : "",
            //     Science: isYear > 2 ? values.Ks1Science : "",
            //     Maths: isYear > 2 ? values.Ks1Maths : "",
            //     PE: ""
            //   }
            // },
          };
          updatePupil(pupilFormData);
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, }) => (
          <Form onSubmit={handleSubmit} className="modal-form" style={style.modal_form} >
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>{Common.ForeName}</Form.Label>
              <Form.Control placeholder={Common.ForeName} type="text" name={Common.Forename} onChange={handleChange} onBlur={handleBlur} value={values.foreName} />
              {errors.foreName && touched.foreName && errors.foreName && (<small style={styles.error_message}> {errors.foreName} </small>)}
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>{Common.SurName}</Form.Label>
              <Form.Control type="text" placeholder={Common.SurName} name={Common.Surname} onChange={handleChange} onBlur={handleBlur} value={values.surName} /> {errors.surName && touched.surName && errors.surName && (<small style={styles.error_message}> {errors.surName} </small>)}
            </Form.Group>
            <Form.Group>
              <Row>
                <Col><Form.Label for="Sen_Status"> {Common.SenStatus} </Form.Label>
                  {defaultOption === undefined ? (
                    <Select defaultValue={setDefaultDropDown()} onChange={(e) => { getSelectedValue(e); }} options={SenStatusOptions} placeholder={Common.PleaseSelect} />) : (
                    <div>
                      {defaultOption && (
                        <Select defaultValue={setDefaultDropDown()} onChange={(e) => { getSelectedValue(e); }} options={SenStatusOptions} placeholder={Common.PleaseSelect} />)}
                    </div>
                  )}
                  {errors.senStatus && touched.senStatus && errors.senStatus}</Col>
                {false && <Col>
                  <Form.Label for="Gender"> {Common.Gender} </Form.Label>
                  {isGender && <Select defaultValue={isGender ? { label: isGender, value: isGender } : (genderOptions && genderOptions[0])} onChange={(e) => setIsGender(e?.value)} options={genderOptions} placeholder={Common.PleaseSelect} />}
                  {errors.gender && touched.gender && errors.gender}
                </Col>}
              </Row>&nbsp;
              {false && <Row>
                <Col><Form.Label for="Year"> {Common.Year} </Form.Label>
                  {isYear && <Select defaultValue={isYear ? { label: `${Common.Year} ${isYear}`, value: isYear } : (yearOptions && yearOptions[0])} onChange={(e) => { setIsYear(e?.value); setWarning(pupilPresentYear && pupilPresentYear !== e?.value) }} options={yearOptions} placeholder={Common.PleaseSelect} />}
                  {errors.year && touched.year && errors.year}
                </Col>
                {warning && <small style={styles.error_message}><img src={warningImg} alt="" width={20} height={20}/>{WARNING.MarkingData}</small>}
              </Row>}
              {false && isYear > 2 && <Row>
                <Col><Form.Label for="KS1Maths"> {BigPictureDashBoardPieChartLegend.Ks1Maths} </Form.Label>
                  {ksResult && <Select defaultValue={ksResult ? { label: ksResult?.ks1Results.Maths, value: ksResult?.ks1Results.Maths } : (commonKS && commonKS[0])} options={commonKS} onChange={(selectedOption) => { handleChange("Ks1Maths")(selectedOption.value); }} placeholder={Common.PleaseSelect} />}
                </Col>
                <Col><Form.Label for="KS1Science"> {BigPictureDashBoardPieChartLegend.Ks1Science} </Form.Label>
                  {ksResult && <Select defaultValue={ksResult ? { label: ksResult?.ks1Results.Science, value: ksResult?.ks1Results.Science } : (commonKSScience && commonKSScience[0])} onChange={(selectedOption) => { handleChange("Ks1Science")(selectedOption.value); }} options={commonKSScience} placeholder={Common.PleaseSelect} />}
                </Col>
                <Col><Form.Label for="KS1Reading"> {BigPictureDashBoardPieChartLegend.Ks1Reading} </Form.Label>
                  {ksResult && <Select defaultValue={ksResult ? { label: ksResult?.ks1Results.Reading, value: ksResult?.ks1Results.Reading } : (commonKS && commonKS[0])} options={commonKS} onChange={(selectedOption) => { handleChange("Ks1Reading")(selectedOption.value); }} placeholder={Common.PleaseSelect} />}
                </Col>
                <Col><Form.Label for="KS1Writing"> {BigPictureDashBoardPieChartLegend.Ks1Writing} </Form.Label>
                  {ksResult && <Select defaultValue={ksResult ? { label: ksResult?.ks1Results.Writing, value: ksResult?.ks1Results.Writing } : (commonKS && commonKS[0])} options={commonKS} onChange={(selectedOption) => { handleChange("Ks1Writing")(selectedOption.value); }} placeholder={Common.PleaseSelect} />}
                </Col>
              </Row>}
            </Form.Group>
            <Form.Group style={styles.radioMargin}>
              <Row>
                <Col className="d-flex flex-column">
                  <label>
                    <input type="checkbox" name={Common.MyCheck} onChange={() => { setIsCla(!isCla); }} onBlur={handleBlur} value={Common.ChildLookedAfter} checked={isCla && isCla} />&nbsp; {Common.ChildLookedAfter}
                  </label>
                  <label>
                    <input type="checkbox" name={Common.MyCheck} onChange={() => { setIsFsm(!isFsm); }} onBlur={handleBlur} value={Common.FreeSchoolMeals} checked={isFsm && isFsm} />&nbsp;
                    {Common.FreeSchoolMeals}
                  </label>
                  <label>
                    <input type="checkbox" name={Common.MyCheck} onChange={() => { setIsSc(!isSc); }} onBlur={handleBlur} value={Common.ServiceChild} checked={isSc && isSc} />&nbsp;
                    {Common.ServiceChild}
                  </label>
                </Col>
                <Col className="d-flex flex-column">
                  <label>
                    <input type="checkbox" name={Common.MyCheck} onChange={() => { setIsEal(!isEal); }} onBlur={handleBlur} value={Common.EnglishAsAnAdditionalLanguage} checked={isEal && isEal} />&nbsp;
                    {Common.EnglishAsAnAdditionalLanguage}
                  </label>
                  <label>
                    <input type="checkbox" name={Common.MyCheck} onChange={() => { setIsFsm6(!isFsm6); }} onBlur={handleBlur} value={Common.FreeSchoolMealsEver6} checked={isFsm6 && isFsm6} />&nbsp;
                    {Common.FreeSchoolMealsEver6}
                  </label>
                </Col>
              </Row>
              {errors.myCheck && touched.myCheck && errors.myCheck}
            </Form.Group>
            <Form.Group>
              <Button variant="outline-secondary" onClick={() => { setEditPupil(false); }} >{Common.Cancel}</Button>&nbsp;
              <Button type="submit" variant="success" disabled={isSubmitting} >{Common.Update}</Button>
            </Form.Group>
          </Form>
        )}
      </Formik>
    </>
  );
}

export { EditPupil };
